(function () {
    function selectCard(card) {
        var rowHandle = card.closest('[data-topcard-row]')?.getAttribute('data-topcard-row');
        var topcardHandle = card.getAttribute('data-topcard-handle');
        if (!rowHandle || !topcardHandle) return;

        document.querySelectorAll('[data-topcard-row="' + rowHandle + '"]').forEach(function (row) {
            row.querySelectorAll('.topcard-jul-item.is-selected').forEach(function (el) {
                el.classList.remove('is-selected');
                el.classList.remove('d-none');
            });
            var match = row.querySelector('[data-topcard-handle="' + topcardHandle + '"]');
            if (!match) return;

            // The selected card points at where you already are, so hide it instead of
            // marking it - same idea as the control variant hiding the current collection's card.
            match.classList.add('is-selected');
            match.classList.add('d-none');

            var swiperEl = row.querySelector('.swiper');
            if (swiperEl && swiperEl.swiper) {
                swiperEl.swiper.update();
            }
        });
    }

    function parseFilterSpec(spec) {
        if (!spec) return null;
        var separatorIndex = spec.indexOf(':');
        if (separatorIndex === -1) return null;
        return {
            name: spec.slice(0, separatorIndex).trim(),
            value: spec.slice(separatorIndex + 1).trim()
        };
    }

    function getActiveFilterParam() {
        var queryParams = new URLSearchParams(window.location.search);
        var active = null;
        queryParams.forEach(function (value, key) {
            if (!active && key.indexOf('filter.') === 0) {
                active = { name: key, value: value };
            }
        });
        return active;
    }

    function getCurrentCollectionHandle() {
        var el = document.querySelector('[data-default-col-card]');
        var val = el && el.getAttribute('data-default-col-card');
        return val ? val.replace('collection-', '') : null;
    }

    function setCurrentCollectionHandle(handle) {
        var el = document.querySelector('[data-default-col-card]');
        if (el) el.setAttribute('data-default-col-card', 'collection-' + handle);
    }

    function getRowCanonicalHandle(row) {
        var remover = row && row.querySelector('[data-card-type="Filter Remover"]');
        return remover ? remover.getAttribute('data-col-handle') : null;
    }

    function applySelectionFromUrl(row) {
        if (!row) return;

        var activeParam = getActiveFilterParam();
        var cardToSelect = null;
        var matchedFilterCard = false;

        if (activeParam) {
            var filterCards = row.querySelectorAll('[data-filter-specs]');
            for (var i = 0; i < filterCards.length; i++) {
                var parsed = parseFilterSpec(filterCards[i].getAttribute('data-filter-specs'));
                if (parsed && parsed.name === activeParam.name && parsed.value === activeParam.value) {
                    cardToSelect = filterCards[i];
                    matchedFilterCard = true;
                    break;
                }
            }
        }

        if (!cardToSelect) {
            var currentHandle = getCurrentCollectionHandle();
            if (currentHandle) {
                cardToSelect = row.querySelector('[data-col-handle="' + currentHandle + '"]');
            }
        }

        if (!cardToSelect) {
            cardToSelect = row.querySelector('[data-card-type="Filter Remover"]');
        }

        if (cardToSelect) {
            selectCard(cardToSelect);
            if (matchedFilterCard) {
                appendFilterBreadcrumb(getCardTitle(cardToSelect));
            }
        }
    }

    function dispatchParamChange() {
        // skipScroll: new topcards swap the collection in place, so we must not jump the
        // viewport (that hides the collection title sitting above the topcard row).
        window.dispatchEvent(new CustomEvent('paramchange', { detail: { message: 'Parameter Change', skipScroll: true } }));
    }

    function getCardTitle(card) {
        var title = card.getAttribute('data-card-title');
        if (!title) {
            var textEl = card.querySelector('.topcard-text');
            if (textEl) {
                title = textEl.textContent.trim();
            }
        }
        return (title || '').replace(/\(AB\)/g, '')
                             .replace(/\(Filter\)/g, '')
                             .replace(/\(Top\)/g, '')
                             .replace(/\(Apparel\)/g, '')
                             .replace(/\(HW\)/g, '')
                             .trim()
                             .replace(/^All\s+/, '');
    }

    function pushTopcardClickEvent(collectionHandle, cardTitle) {
        window.VWO = window.VWO || [];
        window.VWO.event = window.VWO.event || function () { window.VWO.push(["event"].concat([].slice.call(arguments))); };
        window.VWO.event("topCardClick", {
            "level1": collectionHandle || "",
            "level2": "",
            "level3": cardTitle || ""
        });
        console.log({
            "level1": collectionHandle || "",
            "level2": "",
            "level3": cardTitle || ""
        });
    }

    function buildDestinationBreadcrumbSegments(colHandle, cardRow, title) {
        var handleDown = colHandle.toLowerCase();

        if (handleDown === 'all' || handleDown === 'shop-all' || handleDown === 'all-products') {
            return [{ text: 'Shop All', href: null }];
        }

        var segments = [{ text: 'Shop All', href: '/collections/new-arrivals' }];

        var isChildOfUnderwear = false;
        var isChildOfBras = false;

        var cardRowHandle = cardRow ? (cardRow.getAttribute('data-topcard-row') || '').toLowerCase() : '';

        if (cardRowHandle.indexOf('bottom') !== -1 || cardRowHandle.indexOf('underwear') !== -1) {
            isChildOfUnderwear = true;
        } else if (cardRowHandle.indexOf('top') !== -1 || cardRowHandle.indexOf('bralette') !== -1 || cardRowHandle.indexOf('bra') !== -1) {
            isChildOfBras = true;
        }

        if (isChildOfUnderwear && handleDown !== 'underwear') {
            segments.push({ text: 'Underwear', href: '/collections/underwear' });
        } else if (isChildOfBras && handleDown !== 'bralettes-and-tops') {
            segments.push({ text: 'Bras', href: '/collections/bralettes-and-tops' });
        }

        var displayTitle = title;
        if (handleDown === 'underwear') displayTitle = 'Underwear';
        if (handleDown === 'bralettes-and-tops') displayTitle = 'Bras';
        if (handleDown === 'all-support') displayTitle = 'Bras';
        if (handleDown === 'period-protection') displayTitle = 'Period Protection';
        if (handleDown === 'active-collection' || handleDown === 'activewear' || handleDown === 'active') displayTitle = 'Activewear';
        if (handleDown === 'swim-collection' || handleDown === 'swim') displayTitle = 'Swim';
        if (handleDown === 'sleep-collection' || handleDown === 'sleep') displayTitle = 'Sleep';
        if (handleDown === 'apparel-and-accessories' || handleDown === 'apparel' || handleDown === 'accessories') displayTitle = 'Apparel and Accessories';
        if (handleDown === 'new-arrivals' || handleDown === 'new') displayTitle = 'New Arrivals';

        segments.push({ text: displayTitle, href: '/collections/' + colHandle });

        if (title.toLowerCase() === 'packs') {
            segments.push({ text: title, href: '/collections/' + colHandle });
        }

        return segments;
    }

    function renderBreadcrumbSegments(segments) {
        var breadcrumbContainer = document.querySelector('.breadcrumb-wrapper.topcart-breadcrumps');
        if (!breadcrumbContainer) return;

        var html = '';
        segments.forEach(function (segment, index) {
            var isLast = index === segments.length - 1;
            if (isLast || !segment.href) {
                var attr = segment.isFilter ? 'data-filter-breadcrumb' : 'data-final-breadcrumb';
                html += '<span ' + attr + ' class="">' + segment.text + '</span>';
            } else {
                var isFilterBase = segments[index + 1] && segments[index + 1].isFilter;
                html += '<a class="text-black bread-link"' + (isFilterBase ? ' data-breadcrumb-filter-remover' : '') + ' href="' + segment.href + '">' + segment.text + '</a> <span> / </span>';
            }
        });
        breadcrumbContainer.innerHTML = html;

        wireFilterRemoverBreadcrumbLink();
    }

    function wireFilterRemoverBreadcrumbLink() {
        var link = document.querySelector('.breadcrumb-wrapper.topcart-breadcrumps [data-breadcrumb-filter-remover]');
        if (!link || link.dataset.wired) return;
        link.dataset.wired = 'true';

        link.addEventListener('click', function (event) {
            var filterRemoverCard = document.querySelector('.topcard-jul-row:not(.d-none) [data-card-type="Filter Remover"]');
            if (!filterRemoverCard) return;

            event.preventDefault();
            handleFilterRemover(filterRemoverCard);
        });
    }

    function getCurrentBreadcrumbSegments() {
        var breadcrumbContainer = document.querySelector('.breadcrumb-wrapper.topcart-breadcrumps');
        if (!breadcrumbContainer) return [];

        var segments = [];
        Array.from(breadcrumbContainer.children).forEach(function (el) {
            if (el.hasAttribute('data-filter-breadcrumb')) return;
            if (el.tagName === 'A') {
                segments.push({ text: el.textContent.trim(), href: el.getAttribute('href') });
            } else if (el.tagName === 'SPAN' && !el.classList.contains('last-divider')) {
                var text = el.textContent.trim();
                if (text && text !== '/') {
                    segments.push({ text: text, href: null });
                }
            }
        });

        if (segments.length) {
            var lastSegment = segments[segments.length - 1];
            if (!lastSegment.href) {
                var currentHandle = getCurrentCollectionHandle();
                if (currentHandle) {
                    lastSegment.href = '/collections/' + currentHandle;
                }
            }
        }

        return segments;
    }

    function updateBreadcrumbs(card) {
        var colHandle = card.getAttribute('data-col-handle');
        if (!colHandle) return;

        var title = getCardTitle(card);
        var cardRow = card.closest('[data-topcard-row]');
        renderBreadcrumbSegments(buildDestinationBreadcrumbSegments(colHandle, cardRow, title));
    }

    function appendFilterBreadcrumb(filterTitle) {
        var segments = getCurrentBreadcrumbSegments();
        if (!segments.length || !filterTitle) return;
        segments.push({ text: filterTitle, href: null, isFilter: true });
        renderBreadcrumbSegments(segments);
    }

    function removeFilterBreadcrumb() {
        var segments = getCurrentBreadcrumbSegments();
        if (!segments.length) return;
        renderBreadcrumbSegments(segments);
    }

    function setCollectionContext(colHandle) {
        setCurrentCollectionHandle(colHandle);
        document.querySelector('.collection-header')?.setAttribute('data-collection-handle', colHandle);
        document.querySelector('.collection-sticky-menu')?.setAttribute('data-collection-handle', colHandle);
    }

    function showRowGroup(rowHandle) {
        var targetRows = document.querySelectorAll('.topcard-jul-row[data-topcard-row="' + rowHandle + '"]');
        if (!targetRows.length) return null;

        document.querySelectorAll('.topcard-jul-row').forEach(function (row) {
            row.classList.add('d-none');
        });
        targetRows.forEach(function (row) {
            row.classList.remove('d-none');

            var swiperEl = row.querySelector('.swiper');
            if (swiperEl && swiperEl.swiper) {
                swiperEl.swiper.update();
            }
        });

        return targetRows;
    }

    // Every card click swaps the collection in place, so each one needs its own history
    // entry (pushState) plus a snapshot of what the page looked like, otherwise Back
    // leaves the collection entirely instead of stepping back through the ajax views.
    function captureState() {
        var visibleRow = document.querySelector('.topcard-jul-row:not(.topcard-jul-sticky-row):not(.d-none)')
            || document.querySelector('.topcard-jul-row:not(.d-none)');
        var selected = visibleRow && visibleRow.querySelector('.topcard-jul-item.is-selected');
        var breadcrumbContainer = document.querySelector('.breadcrumb-wrapper.topcart-breadcrumps');

        return {
            topcardJul: true,
            colHandle: getCurrentCollectionHandle(),
            rowHandle: visibleRow ? visibleRow.getAttribute('data-topcard-row') : null,
            selectedHandle: selected ? selected.getAttribute('data-topcard-handle') : null,
            breadcrumbHtml: breadcrumbContainer ? breadcrumbContainer.innerHTML : null
        };
    }

    function navigateTo(url) {
        var absolute = new URL(url, window.location.href).href;
        if (absolute === window.location.href) return;
        history.pushState(null, null, absolute);
    }

    function commitState() {
        history.replaceState(captureState(), null, window.location.href);
    }

    function restoreState(state) {
        var selectedCard = null;

        if (state.rowHandle) {
            showRowGroup(state.rowHandle);

            if (state.selectedHandle) {
                selectedCard = document.querySelector('.topcard-jul-row[data-topcard-row="' + state.rowHandle + '"]'
                    + ' [data-topcard-handle="' + state.selectedHandle + '"]');
                if (selectedCard) selectCard(selectedCard);
            }
        }

        var breadcrumbContainer = document.querySelector('.breadcrumb-wrapper.topcart-breadcrumps');
        if (breadcrumbContainer && typeof state.breadcrumbHtml === 'string') {
            breadcrumbContainer.innerHTML = state.breadcrumbHtml;
            wireFilterRemoverBreadcrumbLink();
        }

        if (state.colHandle) {
            setCollectionContext(state.colHandle);
        }

        // swapProductBundle already fires paramchange when it finds a prerendered bundle;
        // otherwise the products just need a refetch against the restored URL.
        if (!state.colHandle || !swapProductBundle(state.colHandle)) {
            dispatchParamChange();
        }

        if (selectedCard && selectedCard.hasAttribute('data-filter-specs')) {
            applyFilterHero(selectedCard);
        }
    }

    function handlePopState(event) {
        var state = event.state;

        if (state && state.topcardJul) {
            restoreState(state);
            return;
        }

        // Filters/sort elsewhere in the theme replaceState without a state object, which
        // wipes our snapshot off that entry. Nothing left to rebuild from, so let the
        // entry's URL load for real.
        window.location.reload();
    }

    function shouldPreserveTopcardRow(card) {
        return !!document.querySelector('.topcard-ab-b')
            && getCurrentCollectionHandle() === 'shop-all'
            && card.getAttribute('data-topcard-handle') === 'new'
            && card.getAttribute('data-col-handle') === 'new-arrivals';
    }

    function handleOpenNewCard(card, keepCurrentRow) {
        var preserveTopcardRow = keepCurrentRow || shouldPreserveTopcardRow(card);

        selectCard(card);

        var colHandle = card.getAttribute('data-col-handle');
        if (colHandle) {
            setCollectionContext(colHandle);

            var newUrl = window.location.origin + '/collections/' + colHandle;
            var parsedFilter = parseFilterSpec(card.getAttribute('data-filter-specs'));
            if (parsedFilter) {
                var queryParams = new URLSearchParams();
                queryParams.set(parsedFilter.name, parsedFilter.value);
                newUrl += '?' + queryParams.toString();
            }
            navigateTo(newUrl);
        }

        if (!preserveTopcardRow) {
            var childGroupHandle = card.getAttribute('data-child-group');
            if (childGroupHandle) {
                var targetRows = showRowGroup(childGroupHandle);
                if (targetRows) {
                    applySelectionFromUrl(targetRows[0]);
                }
            }
        }

        if (colHandle) {
            swapProductBundle(colHandle);
            updateBreadcrumbs(card);

            if (card.hasAttribute('data-filter-specs')) {
                applyFilterHero(card);
            }
        }

        commitState();
    }

    function setHeroTitle(title) {
        var heroTitle = document.querySelector('.collection-hero__title');
        if (heroTitle && title) {
            heroTitle.textContent = title;
        }
    }

    function setHeroDescription(description) {
        var heroDescription = document.querySelector('.collection-hero__description');
        if (!heroDescription) return;
        heroDescription.textContent = description || '';
        heroDescription.classList.toggle('d-none', !description);
    }

    function updateHero(source) {
        // No hero data on this bundle - leave the hero alone rather than half-updating it.
        if (!source || !source.hasAttribute('data-hero-title')) return;

        setHeroTitle(source.getAttribute('data-hero-title'));
        setHeroDescription(source.getAttribute('data-hero-description'));
    }

    function applyFilterHero(card) {
        setHeroTitle(getCardTitle(card));
        setHeroDescription(null);
    }

    // A collection can have more than one prerendered bundle (the control topcard loops and
    // the jul destinations both emit one), so prefer whichever carries the hero data.
    function findProductBundle(colHandle) {
        var selector = '[data-plp-new-structure-products="collection-' + colHandle + '"]';
        return document.querySelector(selector + '[data-hero-title]') || document.querySelector(selector);
    }

    function swapProductBundle(colHandle) {
        var targetBundle = findProductBundle(colHandle);
        if (!targetBundle) return false;

        document.querySelectorAll('.collection-bundle').forEach(function (bundle) {
            bundle.classList.add('d-none');
        });
        targetBundle.classList.remove('d-none');

        updateHero(targetBundle);

        dispatchParamChange();

        return true;
    }

    function applyFilterSpec(spec) {
        var parsed = parseFilterSpec(spec);
        if (!parsed) return;

        var queryParams = new URLSearchParams(window.location.search);

        Array.from(queryParams.keys()).forEach(function (key) {
            if (key.indexOf('filter.') === 0) {
                queryParams.delete(key);
            }
        });
        queryParams.set(parsed.name, parsed.value);

        navigateTo(window.location.pathname + '?' + queryParams.toString());
        dispatchParamChange();
    }

    function redirectToCanonicalIfNeeded(card, filterSpec) {
        var row = card.closest('.topcard-jul-row');
        var canonicalHandle = getRowCanonicalHandle(row);
        var currentHandle = getCurrentCollectionHandle();

        if (!canonicalHandle || !currentHandle || canonicalHandle === currentHandle) {
            return false;
        }

        var targetUrl = window.location.origin + '/collections/' + canonicalHandle;
        var parsed = parseFilterSpec(filterSpec);
        if (parsed) {
            var queryParams = new URLSearchParams();
            queryParams.set(parsed.name, parsed.value);
            targetUrl += '?' + queryParams.toString();
        }

        window.location.href = targetUrl;
        return true;
    }

    function handleFilter(card) {
        var filterSpec = card.getAttribute('data-filter-specs');
        if (redirectToCanonicalIfNeeded(card, filterSpec)) return;

        selectCard(card);
        applyFilterSpec(filterSpec);
        appendFilterBreadcrumb(getCardTitle(card));
        applyFilterHero(card);
        commitState();
    }

    function handleFilterRemover(card) {
        if (redirectToCanonicalIfNeeded(card, null)) return;

        selectCard(card);

        var queryParams = new URLSearchParams(window.location.search);
        Array.from(queryParams.keys()).forEach(function (key) {
            if (key.indexOf('filter.') === 0) {
                queryParams.delete(key);
            }
        });
        var newSearch = queryParams.toString();
        navigateTo(window.location.pathname + (newSearch ? '?' + newSearch : ''));
        dispatchParamChange();
        removeFilterBreadcrumb();

        var currentHandle = getCurrentCollectionHandle();
        updateHero(currentHandle && findProductBundle(currentHandle));

        commitState();
    }

    function handleCardClick(event) {
        var card = event.currentTarget;
        var cardType = card.getAttribute('data-card-type');

        pushTopcardClickEvent(getCurrentCollectionHandle(), getCardTitle(card));

        if (cardType === 'Redirect') {
            return;
        }

        if (window.innerWidth <= 768 && card.closest('.topcard-jul-sticky-row')) {
            window.scrollTo(0, 0);
        }

        event.preventDefault();

        if (cardType === 'Open New Card') {
            handleOpenNewCard(card, false);
        } else if (cardType === 'Open Collection') {
            handleOpenNewCard(card, true);
        } else if (cardType === 'Filter') {
            handleFilter(card);
        } else if (cardType === 'Filter Remover') {
            handleFilterRemover(card);
        }
    }

    function init() {
        document.querySelectorAll('.topcard-jul-row [data-card-type]').forEach(function (card) {
            card.addEventListener('click', handleCardClick);
        });

        applySelectionFromUrl(document.querySelector('.topcard-jul-row:not(.d-none)'));
        wireFilterRemoverBreadcrumbLink();

        // Seed the landing entry so stepping back to it restores the server-rendered view.
        commitState();
        window.addEventListener('popstate', handlePopState);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
